import type { SettingsValueProps } from './types';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeColorPresets: 'default',
  themeContrast: 'default',
  themeDirection: 'ltr',
  themeLayout: 'vertical',
  themeMode: 'light',
  themeStretch: false,
  visible: true,
};
